module.exports = __webpack_public_path__ + "img/modulbank.2d5df1cc.png";